module.exports = __webpack_public_path__ + "img/back_1000.8b845dba.png";